<template>
  <v-card class="wrapper table-wrapper d-flex flex-column pa-4 ma-0 gap-1">
    <AppBar
      :secondary="secondary"
      :third="third"
      :id="itemID"
      :edit="isEditMode"
      :loader="isLoading"
      @get-items="handleGetItems"
      @open-filters="handleFilters"
      @click-save-and-return="handleSaveAndReturn"
      :salary-factor-items="items"
      :isDisabled="isDisabled"
    />
    <div
      v-if="initialLoading"
      class="mt-4"
      style="height: calc(100vh - 158px); overflow: hidden"
    ></div>
    <TablePersonnelList
      v-show="!initialLoading"
      :save-return="saveReturn"
      @call-refresh="handleChange"
      @again-ready-to-save="handleSave"
      @initial-Loading-is="handleLoading"
      :call-refresh="refresh"
      @open-calc-dialog="handleCalcDialog"
      @salary-factor-items="handleItems"
      class=""
    />
    <CalcDialog
      :calc="calc"
      :after-save="afterSave"
      :row-data="rowData"
      @close="handleClose"
    />
    <!-- Refresh overlay -->
    <v-overlay absolute :value="refresh" opacity="0.1">
      <v-progress-circular indeterminate size="26" width="3" color="primary" />
    </v-overlay>
  </v-card>
</template>

<script>
import AppBar from "@/views/dashboard/pages/payroll/saleryOperations/partial/AppBar.vue";
import TableList from "@/views/dashboard/pages/payroll/saleryOperations/partial/TableList.vue";
import TablePersonnelList from "@/views/dashboard/pages/payroll/saleryOperations/partial/TablePersonnelList.vue";
import CalcDialog from "./partial/details/CalcDialog.vue";

export default {
  name: "salaryOperation",
  components: {
    AppBar,
    TableList,
    TablePersonnelList,
    CalcDialog,
  },
  data: () => ({
    refresh: false,
    openNavigationDrawer: false,
    initialLoading: true,
    secondary: false,
    third: false,
    isLoading: false,
    isEditMode: false,
    items: null,
    itemID: null,
    List: true,
    saveReturn: false,
    isDisabled: false,
    calc: false,
    afterSave: false,
    rowData: [],
  }),
  created() {
    this.secondary = true;
    this.third = true;
  },
  methods: {
    handleItems(val) {
      this.items = val;
    },
    handleGetItems() {
      this.refresh = true;
      this.initialLoading = false;
    },
    handleChange() {
      this.refresh = false;
    },
    handleFilters() {
      this.openNavigationDrawer = true;
    },
    handleSaveAndReturn() {
      this.saveReturn = true;
    },
    handleSave() {
      this.saveReturn = false;
    },
    handleCloseFilter() {
      this.openNavigationDrawer = false;
    },
    handleLoading(val) {
      this.initialLoading = val;
    },
    handleClose() {
      this.calc = false;
      this.afterSave = false;
    },
    handleCalcDialog(val) {
      this.calc = true;
      this.afterSave = true;
      this.rowData = val;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
.table-wrapper {
  position: relative;
  min-height: 300px;
}
</style>
